import React from 'react';
import { Loader2 } from 'lucide-react';

export function LoadingSpinner() {
  return (
    <div className="fixed inset-0 bg-black/50 backdrop-blur-sm z-50 flex items-center justify-center">
      <div className="bg-white rounded-lg p-8 flex flex-col items-center">
        <Loader2 className="w-12 h-12 text-purple-600 animate-spin" />
        <p className="mt-4 text-gray-600">Chargement...</p>
      </div>
    </div>
  );
}